import {NextSeo} from 'next-seo'
import {useRouter} from 'next/router'

type SeoInformation = {
  pageTitle: string
  pageDescription: string
  canonicalUrl?: string
  image?: string
}

function SeoInformation({pageTitle, pageDescription, canonicalUrl, image}: SeoInformation) {
  const router = useRouter()
  const defaultUrl = `https://www.deliriouseyewear.com${router.asPath.split('?')[0]}`
  const absoluteImageUrl = image
    ? image.startsWith('http')
      ? image
      : `https://www.deliriouseyewear.com${image}`
    : undefined

  return (
    <NextSeo
      title={`${pageTitle}`}
      description={pageDescription}
      canonical={canonicalUrl || defaultUrl}
      openGraph={{
        type: 'article',
        url: canonicalUrl || defaultUrl,
        title: `${pageTitle}`,
        description: pageDescription,
        images: absoluteImageUrl ? [{url: absoluteImageUrl, alt: pageTitle}] : undefined,
      }}
      twitter={{
        cardType: image ? 'summary_large_image' : 'summary',
        site: '@delirious_it',
      }}
      additionalMetaTags={[
        {
          property: 'og:description',
          content: pageDescription,
        },
        {
          name: 'twitter:title',
          content: pageTitle,
        },
        {
          name: 'twitter:description',
          content: pageDescription,
        },
        // Image handling for both platforms
        ...(absoluteImageUrl
          ? [
              {
                property: 'og:image',
                content: absoluteImageUrl,
              },
              {
                name: 'twitter:image',
                content: absoluteImageUrl,
              },
            ]
          : []),
      ]}
    />
  )
}

export default SeoInformation
